import * as React from "react";
import PropTypes from "prop-types";
import capitalize from "lodash-es/capitalize";
import { useFormikContext } from "formik";

import Stack from "@mui/material/Stack";
import { FormTextField } from "ui/Form";

const NameSection = ({ isEdit }) => {
  const {
    values: { mode },
  } = useFormikContext();

  return (
    <Stack gap="16px">
      <FormTextField name="name" label="Theme name" disabled={isEdit} />
      <FormTextField
        name={`${mode}.name`}
        label={`${capitalize(mode)} theme name`}
      />
    </Stack>
  );
};

NameSection.propTypes = {
  isEdit: PropTypes.bool,
};

export default NameSection;
